import sortResourceElementsFunction from "../../functions/sortResourceElementsAPI";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";

const sortResourceElements = async (dispatch, jsonViewEditingState, setJsonViewEditingState, apiToken) => {
    dispatch(globalLoadingOn());
    let sourceJson = JSON.stringify(JSON.parse(jsonViewEditingState.fhirEntryString), null, 2);
    let sortResourceElementsResponse = await sortResourceElementsFunction(sourceJson, apiToken);
    dispatch(globalLoadingOff());
    if (sortResourceElementsResponse.success) {
        if (sourceJson !== sortResourceElementsResponse.sortedJson) {
            if (sourceJson.length === sortResourceElementsResponse.sortedJson.length) {
                if (sortResourceElementsResponse["non-spec-elements"]) {
                    //console.log(sortResourceElementsResponse["non-spec-elements"]);
                    alert("Sort completed, but some possibly non-FHIR elements found: " + sortResourceElementsResponse["non-spec-elements"].map((entry) => { return Object.keys(entry) }).join(', ') + "\nWe don't save the element order, you can copy the JSON for your own use.");
                }
            } else {
                alert("WARNING the sorted Resource is a different size than the original. That likely means some content has been lost. We DO NOT recommend saving these change.");
            }
            setJsonViewEditingState(prevState => {
                return {
                    ...prevState,
                    fhirEntryStringRevised: sortResourceElementsResponse.sortedJson,
                    fhirEntryStringChange: true
                };
            });
        } else {
            alert("No element order changes made.");
        }
    } else if (sortResourceElementsResponse.message) {
        alert("Unable to sort the order of the elements. " + sortResourceElementsResponse.error);
    } else {
        alert("Unable to sort the order of the elements.");
    }
}

export default sortResourceElements;